import React from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import MDBox from "../../../materialDashboard/components/MDBox";
import {  useIncidentPre2021Query, useUpdateIncidentPre2021 } from "../query";
import IncidentForm from "./IncidentForm";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import LoadingOverlay from "../../../components/LoadingOverlay";


const IncidentEdit = () => {
    const {t} = useTranslation(['incidents']);
    const navigate = useNavigate();
    const {incidentId} = useParams();
    const incidentQuery = useIncidentPre2021Query(incidentId);
    const updateIncident = useUpdateIncidentPre2021(incidentId);
    const {showSuccessNotification}  = useFeedbackTools();

    const handleSubmit = async (data) => {
        await updateIncident.mutateAsync(data);
        showSuccessNotification(t('query.updateSuccess'));
        await navigate('/incidents');
    }

    if (incidentQuery.isLoading) {
        return <LoadingOverlay />
    }

    return <MDBox sx={{mx: 2}}>
        <IncidentForm title={t('incidentEdit.title')}
                      incident={incidentQuery.data}
                      onSubmit={handleSubmit}/>
    </MDBox>
}

export default IncidentEdit;